{{#if show_modal}}
  <p class="header {{resource_header_class}}">
    {{#if separate_resource_modal_link}}
      {{name}}
    {{/if}}
    {{#if resource_modal_prefix}}
    <a href="#" id="{{resource_modal_prefix}}-resource-link-{{id}}" data-toggle="modal" data-backdrop="false" data-target="#{{resource_modal_prefix}}-resource-modal-{{id}}">
      {{#if image_url}}<img class="resource-image" src="{{image_url}}"/>{{/if}}
      {{#if badge_class}}
        <div class="{{badge_class}}">
          {{#if badge_text}}
            <div class="screen-reader-content">{{t badge_text}}</div>
          {{/if}}
        </div>
      {{/if}}
      <div>
        <span>{{#if resource_modal_link_copy}}{{t resource_modal_link_copy}}{{else}}{{name}}{{/if}}</span>
        <span class="screen-reader-content">{{t sr_link}}</span>
      </div>
    </a>
    {{else}}
    <div>
      <a href="#" id="resource-link-{{id}}" data-toggle="modal" data-backdrop="false" data-target="#resource-modal-{{id}}">
        {{#if image_url}}<img class="resource-image" src="{{image_url}}"/>{{/if}}
        {{#if badge_class}}
          <div class="{{badge_class}}">
            {{#if badge_text}}
              <div class="screen-reader-content">{{t badge_text}}</div>
            {{/if}}
          </div>
        {{/if}}
        <span>{{#if resource_modal_link_copy}}{{t resource_modal_link_copy}}{{else}}{{name}}{{/if}}</span>
        <span class="screen-reader-content">{{t sr_link}}</span>
      </a>
    </div>
    {{/if}}
  </p>
  <div class="modal" id="{{#if resource_modal_prefix}}{{resource_modal_prefix}}-{{/if}}resource-modal-{{id}}" tabindex="-1" role="dialog" aria-labelledby="{{#if resource_modal_prefix}}{{resource_modal_prefix}}-{{/if}}resource-modal-{{id}}-label" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header {{modal_header_class}}">
          <button type="button" class="{{#if button_class}}{{button_class}}{{/if}} close"
                  data-dismiss="modal" {{#unless prevent_close_feedback}} data-close="true" {{/unless}}>
            {{>icon uuid=cid index=id prefix="fal" name="fa-times" size="fa-lg"}}
            <span class="screen-reader-content">{{#if sr_close_modal}}{{t sr_close_modal}}{{else}}{{t close_modal}}{{/if}}</span>
          </button>

          <{{heading_level}} class="modal-title {{modal_title_class}}" id="{{#if resource_modal_prefix}}{{resource_modal_prefix}}-{{/if}}resource-modal-{{id}}-label">
            {{#if separate_resource_link}}
              {{name}}<span class="screen-reader-content">({{t "newWindow"}})</span>
            {{else}}
              {{#if url}}
                <a href="{{url}}" target="_blank" class="resource-link" rel="noopener noreferrer">
                  {{name}}<span class="screen-reader-content">({{t "newWindow"}})</span>
                </a>
              {{else}}
                {{name}}<span class="screen-reader-content">({{t "newWindow"}})</span>
              {{/if}}
            {{/if}}
          </{{heading_level}}>
        </div>
        <div class="modal-body {{modal_body_class}}" tabindex="0">
          {{#if video_url}}
            <div class="video-container"> </div>
          {{/if}}
          {{#if body}}<div class="marked-down">{{m body}}</div>{{/if}}
          {{#if separate_resource_link}}
            {{#if url}}
              <a href="{{url}}" target="_blank" class="resource-link link" rel="noopener noreferrer">
                {{#if resource_link_copy}}{{t resource_link_copy}}{{else}}{{name}}{{/if}}<span class="screen-reader-content">({{t "newWindow"}})</span>
              </a>
            {{/if}}
          {{/if}}
        </div>
        <div class="modal-footer {{modal_footer_class}}">
          {{#unless hide_esig }}
            {{#if requires_e_signature}}
              {{> e-signature}}
            {{/if}}
          {{/unless}}
          {{#unless hide_close_in_footer}}
            {{#if close_modal}}
              <button type="button" class="modal-footer-close {{#if button_class}}{{button_class}}{{/if}}" data-dismiss="modal" {{#unless prevent_close_feedback}}data-close="true"{{/unless}}>
                {{#if sr_close_modal}}
                  <span aria-hidden="true">{{t close_modal}}</span>
                  <span class="screen-reader-content">{{t sr_close_modal}}</span>
                {{else}}
                  {{t close_modal}}
                {{/if}}
              </button>
            {{/if}}
          {{/unless}}
      </div>
    </div>
  </div>
{{else}}
  <div class="{{resource_header_class}}">
    {{#if separate_resource_link}}
      {{name}}
    {{else}}
      {{#if url}}
        <a href="{{url}}" target="_blank" class="resource-link link" rel="noopener noreferrer">
          {{#if image_url}}<img class="resource-image" src="{{image_url}}"/>{{/if}}
          {{#if badge_class}}
            <div class="{{badge_class}}"></div>
          {{/if}}
          <span>
            {{name}}
          </span>
          <span class="screen-reader-content">({{t "newWindow"}})</span>
        </a>
      {{else}}
        {{name}}
      {{/if}}
    {{/if}}
  </div>
  {{#if body}}<div class="description marked-down {{resource_body_class}}">{{m body}}</div>{{/if}}
  {{#if separate_resource_link}}
    {{#if url}}
      <a href="{{url}}" target="_blank" class="resource-link link" rel="noopener noreferrer">
        {{#if resource_link_copy}}{{t resource_link_copy}}{{else}}{{name}}{{/if}}<span class="screen-reader-content">({{t "newWindow"}})</span>
      </a>
    {{/if}}
  {{/if}}
  <div class="e-sign-container">
    {{#unless hide_esig }}
      {{#if requires_e_signature}}
        {{> e-signature}}
      {{/if}}
    {{/unless}}
  </div>
{{/if}}
